import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DashboardComponent} from '../DashboardModule/DashboardComponent/dashboard.component';
import {UsersListComponent} from '../UsersModule/UsersListComponent/users-list.component';
import {AuthGuard} from '../model/Guards/auth.guard';
import {UserDetailComponent} from '../UsersModule/UserDetailComponent/user-detail.component';
import {UserEditComponent} from '../UsersModule/UserEditComponent/user-edit.component';
import {CustomersListComponent} from '../CustomersModule/CustomersListComponent/customers-list.component';
import {CustomerEditComponent} from '../CustomersModule/CustomerEditComponent/customer-edit.component';
import {CustomerDetailComponent} from '../CustomersModule/CustomerDetailComponent/customer-detail.component';
import {ProductsListComponent} from '../ProductsModule/ProductsListComponent/products-list.component';
import {ProductDetailComponent} from '../ProductsModule/ProductDetailComponent/product-detail.component';
import {ProductEditComponent} from '../ProductsModule/ProductEditComponent/product-edit.component';
import {ContractsListComponent} from '../ContractsModule/ContractsListComponent/contracts-list.component';
import {ContractEditComponent} from '../ContractsModule/ContractEditComponent/contract-edit.component';
import {ContractDetailComponent} from '../ContractsModule/ContractDetailComponent/contract-detail.component';
import {AdminGuard} from '../model/Guards/admin.guard';
import { RevenuePerProductComponent } from '../RevenueModule/RevenuePerProductComponent/revenue-per-product.component';
import {DocumentListComponent} from '../DocumentsModule/DocumentListComponent/document-list.component';
import {DocumentEditComponent} from '../DocumentsModule/DocumentEditComponent/document-edit.component';
import {TransportStatsComponent} from '../TransportModule/TransportStatsComponent/transportStats.component';
import {TransportComponent} from '../TransportModule/TransportComponent/transport.component';
import {TransportRepeatComponent} from '../TransportModule/TransportRepeatComponent/transportRepeat.component';
import {TransportAgendaComponent} from '../TransportModule/TransportAgendaComponent/transportAgenda.component';

/**
 * ROUTING
 * @see https://angular.io/guide/router
 */
const appRoutes: Routes = [
    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard]
    },
    {
        path: '',
        redirectTo: '/dashboard',
        pathMatch: 'full'
    },
    {
        path: 'users',
        component: UsersListComponent,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'user/:id',
        component: UserDetailComponent,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'user/:id/edit',
        component: UserEditComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'customers',
        component: CustomersListComponent,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'customer/:id',
        component: CustomerDetailComponent,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'customer/:id/edit',
        component: CustomerEditComponent,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'products',
        component: ProductsListComponent,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'product/:id',
        component: ProductDetailComponent,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'product/:id/edit',
        component: ProductEditComponent,
        canActivate: [AuthGuard, AdminGuard]
    },
    {
        path: 'contracts',
        component: ContractsListComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'contract/:id',
        component: ContractDetailComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'contract/:id/edit',
        component: ContractEditComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'documents',
        component: DocumentListComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'documents/edit/:id',
        component: DocumentEditComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'documents/create/:type',
        component: DocumentEditComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'documents/create/:type/:contractId',
        component: DocumentEditComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'documents/copy/:type/:documentId',
        component: DocumentEditComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'documents/liquidation/:type/:liquidationId',
        component: DocumentEditComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'revenue',
        component: RevenuePerProductComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'transport-repeat',
        component: TransportRepeatComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'transport',
        component: TransportComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'agenda',
        component: TransportAgendaComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'transport-stats',
        component: TransportStatsComponent,
        canActivate: [AuthGuard]
    }
    // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
            {
                // useHash: true,
                // enableTracing: true     // <-- debugging purposes only
            }
        )
    ],
    exports: [
        RouterModule
    ],
    providers: []
})
export class AppRouterModule {
}



// WEBPACK FOOTER //
// /app/src/routers/app-router.module.ts